import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '@maximizer/core/shared/data-access';
@Pipe({ name: 'quarterFormat', })
export class QuarterFormatPipe implements PipeTransform {
  constructor(private readonly locale: LocaleService) {}

  transform(quarter: number): string {
    return this.locale.intl.dateFormatNames({
      nameType: 'abbreviated',
      type: 'quarters',
    })[quarter - 1];
  }
}
